
import { defineComponent, reactive, toRefs, ref } from 'vue';

export default defineComponent({
  name: 'searchBar',
  components: {},
  props: {
    searchPlaceholder: {
      type: String,
      default: '请输入搜索内容',
    },
    width: {
      type: String,
      default: '19.625rem',
    },
    searchContent: {
      type: String,
      default: '',
    },
  },
  emits: ['update:searchContent', 'on-search'],
  setup(_, { emit }) {
    const inputVal = ref('');
    const methods = reactive({
      //仅在输入框失去焦点或用户按下回车时触发
      doSearchFn: () => {
        emit('update:searchContent', inputVal.value.trim());
        emit('on-search');
      },
      //input值改变时触发
      onInput: () => {
        emit('update:searchContent', inputVal.value.trim());
      },
    });
    return {
      inputVal,
      ...toRefs(methods),
    };
  },
});
